
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Approach from './components/Approach';
import Areas from './components/Areas';
import Services from './components/Services';
import CtaFinal from './components/CtaFinal';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative bg-white">
      <Navbar isScrolled={isScrolled} />
      <Hero />
      <About />
      <Approach />
      <Areas />
      <Services />
      <CtaFinal />
      <Footer />
    </div>
  );
}
